var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolBlueBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5C3 7.84314 3 5.01472 4.75735 3.25735C6.51472 1.5 9.34314 1.5 15 1.5H21C26.6568 1.5 29.4853 1.5 31.2426 3.25735C33 5.01472 33 7.84314 33 13.5V19.5C33 25.1568 33 27.9853 31.2426 29.7426C29.4853 31.5 26.6568 31.5 21 31.5H15C9.34314 31.5 6.51472 31.5 4.75735 29.7426C3 27.9853 3 25.1568 3 19.5V13.5Z",
    fill: "url(#paint0_linear_1879_56600)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 10.75H22.5V11.875H23.25V10.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.125H22.5V10H23.25V8.125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 11.125C23.2892 11.125 23.625 10.7892 23.625 10.375C23.625 9.96079 23.2892 9.625 22.875 9.625C22.4608 9.625 22.125 9.96079 22.125 10.375C22.125 10.7892 22.4608 11.125 22.875 11.125Z",
    fill: "#C6CBE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.82617V9.62492C15 10.4537 15.6712 11.1249 16.5 11.1249H19.5C20.3288 11.1249 21 10.4537 21 9.62492V8.82617L18 9.62492L15 8.82617Z",
    fill: "#C1CFFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.625L12.375 8.125L18 5.125L23.625 8.125L18 9.625Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 26.125V16.375L18 11.875L22.5 16.375V26.125",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C19.0355 19 19.875 18.1605 19.875 17.125C19.875 16.0895 19.0355 15.25 18 15.25C16.9645 15.25 16.125 16.0895 16.125 17.125C16.125 18.1605 16.9645 19 18 19Z",
    fill: "#C6CBE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.625H9.375V26.125H13.5V18.625Z",
    fill: "#D3DBF5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.625 18.625H22.5V26.125H26.625V18.625Z",
    fill: "#D3DBF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.125V23.125H19.5V26.125",
    fill: "#C6CBE0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.375H27.375V18.625H22.5",
    fill: "#E2E8FB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.625H8.625V16.375H13.5",
    fill: "#E2E8FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 26.125H6.75V26.875H29.25V26.125Z",
    fill: "#B5C2EB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 23.125H17.625V26.125H18.375V23.125Z",
    fill: "#C6CBE0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19C16.965 19 16.125 18.16 16.125 17.125C16.125 16.09 16.965 15.25 18 15.25",
    fill: "#C6CBE0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1879_56600",
    x1: 3,
    y1: 16.5,
    x2: 33,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolBlueBuilding);
export default __webpack_public_path__ + "static/media/school_blue_building.022d532fc612482ad102e01f6cd89a4c.svg";
export { ForwardRef as ReactComponent };